import React from "react";
import {Image} from "semantic-ui-react";
import STRATEGIC_PARTNER from "../../../constants/strategicPartners";

const {BASE_URL, APPLICATION, SP_NAME} = STRATEGIC_PARTNER.S3;


const buildS3ImageSrc = (name, svg = false, common = false) => {
    const application = !!common ? 'common' : APPLICATION;
    const extension = !!svg ? 'svg' : 'png';

    return `${BASE_URL}/${SP_NAME}/${application}/${name}.${extension}`;
};

const S3Image = ({common, svg, name, ...otherProps}) =>
    <Image {...otherProps} src={buildS3ImageSrc(name, svg, common)} />;

export { S3Image, buildS3ImageSrc };